export const INBOX_FILTER = "INBOX_FILTER"
export const INBOX_FILTER_SUCCESS = "INBOX_FILTER_SUCCESS"
export const INBOX_FILTER_ERROR = "INBOX_FILTER_ERROR"

export const INBOX_SEGMENTS = "INBOX_SEGMENTS"
export const INBOX_SEGMENTS_SUCCESS = "INBOX_SEGMENTS_SUCCESS"
export const INBOX_SEGMENTS_ERROR = "INBOX_SEGMENTS_ERROR"
